import { useTranslation } from 'react-i18next';
import { IcScreenBig, IcSearchBig } from './icons';

/** first load only: a group header + 5 rows, the prototype's loading state */
export function ListSkeleton() {
  return (
    <div className="pp-ls-wrap" data-testid="list-skeleton" aria-busy="true">
      <div className="pp-ls-grp">
        <div className="pp-ls-sk" style={{ height: 18, width: 140 }} />
        <div className="pp-ls-list">
          {Array.from({ length: 5 }, (_u, i) => (
            <div className="pp-ls-row" style={{ cursor: 'default' }} key={i}>
              <span />
              <div className="pp-ls-sk" style={{ height: 14, width: '70%' }} />
              <div className="pp-ls-sk pp-ls-now" style={{ height: 12, width: '60%' }} />
              <div className="pp-ls-sk" style={{ height: 12, width: '80%' }} />
              <div className="pp-ls-sk" style={{ height: 30, width: 110 }} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export function ListEmpty({ onNew }) {
  const { t } = useTranslation();
  return (
    <div className="pp-ls-blank" data-testid="list-empty">
      <div className="pp-ls-ic"><IcScreenBig /></div>
      <h3>{t('screens_list.empty_title')}</h3>
      <p>{t('screens_list.empty_body')}</p>
      <button type="button" className="pp-ls-btn pp-ls-primary" onClick={onNew}>{t('screens_list.new_screen')}</button>
    </div>
  );
}

export function ListNoResults({ byName, onShowAll }) {
  const { t } = useTranslation();
  return (
    <div className="pp-ls-blank" data-testid="list-no-results">
      <div className="pp-ls-ic"><IcSearchBig /></div>
      <h3>{t('screens_list.nores_title')}</h3>
      <p>{byName ? t('screens_list.nores_name') : t('screens_list.nores_state')}</p>
      <button type="button" className="pp-ls-btn" onClick={onShowAll}>{t('screens_list.show_all')}</button>
    </div>
  );
}
